module.exports = __webpack_public_path__ + "img/zh-reward2.51b742ce.jpg";